(function() { window.GUID_905e43b4_1c83_405c_9114_476986b57be8 = { getGuid: function() { return "905e43b4-1c83-405c-9114-476986b57be8"; } }; })();
var CompuSport;
(function (CompuSport) {
    let currentToolTip;
    function ShowToolTip($target, content = null) {
        if (content != null && content.trim() != "") {
            currentToolTip.ShowToolTip($target, content);
        }
        else {
            currentToolTip.ClearToolTip();
        }
    }
    CompuSport.ShowToolTip = ShowToolTip;
    class Tooltip {
        constructor() {
            this.tooltipTimer = null;
            this.lastToolTip = null;
            let me = this;
            CompuSport.DOM.doc.off('mouseover.cstooltip focusin.cstooltip');
            CompuSport.DOM.doc.on('mouseover.cstooltip focusin.cstooltip', '[data-tooltip]', function (e) {
                var $target = $(e.target).closest('[data-tooltip]');
                me.ShowToolTip($target);
            }).on('mouseleave.cstooltip blur.cstooltip focusout.cstooltip mousewheel.cstooltip', '[data-tooltip]', function (e) {
                me.ClearToolTip();
            }).on('mouseup.cstooltip autocomplete.shown', function () {
                me.ClearToolTip();
            });
        }
        ShowToolTip($target, content = null) {
            let me = this;
            if ($target.is("[title]")) {
                $target
                    .data("keepedTitle", $target.attr("title"))
                    .removeAttr("title");
            }
            me.tooltipTimer = CompuSport.Lag(250, function () {
                if (me.lastToolTip != null) {
                    me.lastToolTip.remove();
                }
                var $tooltip = $('<div id="CSToolTip" class="Content"></div>');
                me.lastToolTip = $tooltip;
                var tooltipVal = $target.attr('data-tooltip');
                if (content != null && content != "") {
                    tooltipVal = content;
                }
                if (tooltipVal == null || tooltipVal == "") {
                    tooltipVal = $target.data('keepedTitle');
                }
                if ($target[0].tagName == "IMG" && $target.data('forcetooltip') == null) {
                    if (tooltipVal != null && tooltipVal != "") {
                        $tooltip[0].innerHTML = "<img class='tooltipOfImg' src=" + tooltipVal + " />";
                    }
                    else {
                        $tooltip[0].innerHTML = "<img class='tooltipOfImg' src=" + $target[0].src + " />";
                    }
                }
                else if (tooltipVal != null && tooltipVal != "") {
                    $tooltip[0].innerHTML = decodeURIComponent(tooltipVal);
                    if ($target.hasClass("IsDisabled")) {
                        $('.HowToEnable', $tooltip).addClass("IsEnabled");
                    }
                }
                else {
                    $tooltip[0].innerHTML = $target[0].title;
                }
                if ($tooltip[0].innerHTML == "") {
                    return;
                }
                $tooltip[0].innerHTML += "<div id='ToolTipArrow'></div>";
                var classToAdd = CompuSport.Layout.PositionTargetRefToSourceAndWindows($target, $tooltip);
                $tooltip.addClass(classToAdd);
                $tooltip.target = $target;
                $target.addClass('Tooltiped');
                $tooltip.appendTo(CompuSport.DOM.body);
                var horizontalOffset = $target.width() - 40;
                var maxHorizontalPosition = Math.max(CompuSport.DOM.win.width() - $tooltip.outerWidth(true), 0);
                if ($tooltip.hasClass('LayoutHelperLeft')) {
                    var left = parseFloat($tooltip.css('left')) + horizontalOffset;
                    $tooltip.css({ 'left': Math.min(Math.max(left, 0), maxHorizontalPosition) + 'px' });
                }
                else {
                    var right = parseFloat($tooltip.css('right')) + horizontalOffset;
                    $tooltip.css({ 'right': Math.min(Math.max(right, 0), maxHorizontalPosition) + 'px' });
                }
            });
        }
        ClearToolTip() {
            let me = this;
            if (me.lastToolTip != null) {
                var $target = me.lastToolTip.target;
                if ($target != null) {
                    $target.removeClass('Tooltiped');
                }
                me.lastToolTip.remove();
            }
            clearTimeout(me.tooltipTimer);
        }
    }
    CompuSport.Tooltip = Tooltip;
    currentToolTip = new Tooltip();
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Tooltip.desktop.js.map
